export enum urlPaths {
    Home = "/",
    ChooseYourHub = "/choose-your-hub",
    Search = "/leadership-dynamics/search",
    Domain = "/leadership-dynamics/domain",
    AdvancedPeersSearch = "/leadership-dynamics/advanced-peers-search",
    MySearches = "/leadership-dynamics/my-searches",
    Team = "/leadership-dynamics/team",
    Vcp = "/leadership-dynamics/vcp",
    Projection = "/leadership-dynamics/insights",
    PaceAssessment = "/pace/assessment",
    PaceLabsDashboard = "/pace/my-dashboard",
    PaceLabsInsights = "/pace/my-insights",
    PaceLabsInsightsLanding = "/pace/my-insights/balance",
    NotFound = "/404",
    Talent = "/talent/companies",
    TalentPeople = "/talent/people",
    TalentRefinement = "/talent/refinement",
    SetupProfile = "/pace/setup",
    AccountManagement = "/account-management/settings",
    AccountPrivacy = "/account-management/privacy",
    ProjectDashboard = "/leadership-dynamics/dashboard",
    Brief = "/leadership-dynamics/brief",
    BriefReview = "/leadership-dynamics/brief/review",
    HubManagement = "/hub-management",
    HubManagementNew = "/hub-management/new",
    HubManagementAddUsers = "/hub-management/add-users",
    HubManagementEditClient = "/hub-management/client",
    UserManagement = "/user-management",
    PacePortal = "/pace/admin",
    PaceLanding = "/pace/assessment",
    PaceDashboard = "/pace/dashboard",
    BehavioralComparison = "/pace/behavioural-comparison",
    MyPace = "/pace/my-pace",
    MyExperience = "/pace/my-experience",
    LeadershipDashboard = "/leadership-dashboard",
    LeadershipOverview = "/leadership-dashboard/overview",
    LeadershipManagement = "/leadership-dashboard/management",
    PathToImprovement = "/leadership-dashboard/path-to-improvement",
}
